module.exports = __webpack_public_path__ + "img/album1.20fa98ee.jpg";